// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Baby } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { clearReadCache } from "@/lib/pwa";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/** Handles the Emergent OAuth callback: extracts session_id from URL fragment,
 *  exchanges it via backend for a JWT cookie, and redirects to the right home. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        // Clean URL fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        // Wis SW cache van vorige sessie (voorkomt data-lek van eerdere user).
        clearReadCache();
        await refresh();
        toast.success(`Welkom, ${data.user.name}`);
        navigate(data.user.role === "ouder" ? "/portaal" : "/app", { replace: true });
      } catch (e) {
        const msg = formatApiError(e.response?.data?.detail) || "Google-inloggen mislukt";
        toast.error(msg);
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--bone)] subtle-grain" data-testid="auth-callback">
      <div className="text-center space-y-3">
        <div className="w-12 h-12 rounded-md mx-auto flex items-center justify-center" style={{ background: "var(--sage)" }}>
          <Baby className="h-6 w-6 text-white animate-pulse" />
        </div>
        <div className="font-display text-lg">Bezig met inloggen…</div>
        <div className="text-xs text-neutral-500">Even geduld, we bevestigen je Google-sessie.</div>
      </div>
    </div>
  );
}
